import axios from 'axios';
import { md5AndRSA } from './md5';
import router from '../router/router';
import { Message, MessageBox, Notification } from 'element-ui'; //导入element-ui组件库
import { getToken, removeToken } from '@/utils/auth';
import Cookies from 'js-cookie';
import errorCode from '@/utils/errorCode';
import store from '../store/index.js';

let showMessageBox = true;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
// 创建axios的对象
const service = axios.create({
  // baseURL: 'http://43.140.247.202:10006', //配置固定域名
  baseURL: process.env.VUE_APP_BASE_API_URL, //配置固定域名
  // baseURL: 'http://43.140.247.202:10006', //配置固定域名
  // // baseURL: process.env.VUE_APP_BASE_API_URL, //配置固定域名
  timeout: 30000,
});

axios.defaults.withCredentials = true; // 让ajax携带cookie
// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
service.interceptors.request.use(
  config => {
    console.log(config, 'config');

    // todo获取请求参数
    var requestData = '';
    if (config.data && !config.params) {
      requestData = JSON.parse(JSON.stringify(config.data));
    } else if (config.params && !config.data) {
      requestData = JSON.parse(JSON.stringify(config.params));
    } else if (config.data == undefined && config.params) {
      requestData = JSON.parse(JSON.stringify(config.params));
    } else if (config.data && config.params) {
      requestData = JSON.parse(JSON.stringify(Object.assign(config.params, config.data)));
    }
    // console.log(requestData, '获取请求参数');

    let parm = md5AndRSA(requestData);

    //! 将随机字符串(MD5密钥)、时间戳、加密参数  添加到请求头中
    config.headers['nonce'] = parm.Data.nonce;
    config.headers['timestamp'] = parm.Data.timestamp;
    config.headers['sign'] = parm.sign;

    // 是否需要设置 token请根据实际情况自行修改
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers['token'] = getToken();
    }

    // Warning:插件市场官方用户token,禁止修改
    // if (config.url.includes('/qaapi/')) {
    config.headers['apitoken'] = Cookies.get('Api-Token');

    // }
    // console.log(config, 'config');
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  res => {
    //存储验证码流key
    if (res.headers.hasOwnProperty('key')) {
      Cookies.set('key', res.headers.key);
    }

    //文件流行为filename获取 响应头content-disposition: inline;filename="export_demo_1641458100.xlsx"
    if (res.headers.hasOwnProperty('content-disposition')) {
      Cookies.set('filename', res.headers['content-disposition'].slice(17, -1));
    }

    // 未设置状态码则默认成功状态
    let code = res.data.code || 1;
    if (res.data.code === 0) code = 0;

    // 获取错误信息
    const msg = errorCode[code] || res.data.msg;
    if (code === 4001) {
      removeToken();
      if (showMessageBox) {
        showMessageBox = false;
        MessageBox.confirm('当前未登录,请重新登录', '系统提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            store.dispatch('LogOut').then(() => {
              showMessageBox = true;
              router.replace('/login');
            });
          })
          .catch(() => {
            showMessageBox = true;
            // router.go(-1)
            router.go(-1);
          });
      }
      return Promise.reject('令牌验证失败');
    }
    if (code === 4002) {
      MessageBox.confirm('无权访问', '系统警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {})
        .catch(() => {});
      return Promise.reject('非法访问');
    }
    if (code === 4005) return Promise.reject(4005);
    if (code === 6001) {
      return Promise.reject(6001);
    } else if (code === 500) {
      Message({ message: msg, type: 'error' });
      return Promise.reject(new Error(msg));
    } else if (code !== 1) {
      Notification.error({ title: msg });
      return Promise.reject(new Error(msg));
    } else {
      return res.data;
    }
  },
  error => {
    console.log(error, ':[Log error] utils request');
    let { message } = error;
    if (message == 'Network Error') {
      message = '系统错误';
    } else if (message.includes('timeout')) {
      message = '系统错误请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统错误' + message.substr(message.length - 3) + '异常';
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 });
    return Promise.reject(error);
  }
);
// function callback(action, instance) {
//   removeToken();
// }

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js